import React from "react";
import { II } from "../../components/common/Icons";
import { PM_NAV } from "../../data/pmData";
import { usePMData } from "../../context/PMContext";
import { useAuth } from "../../context/AuthContext";
import { AvatarDisplay } from "../../components/common/AvatarUpload";import "../../assets/styles/PM/PMSidebar.css";

function PMSidebar({ activeView, setActiveView, onLogout, sidebarOpen, setSidebarOpen }) {
  // ===========================================
  // ðŸ›¡ï¸ ULTIMATE SAFE DATA EXTRACTION
  // ===========================================
  let pmLeaveReqs = [];
  let pmDocs = [];
  let pmHrReports = [];
  let pmSchedules = [];
  let pmAdvances = [];

  try {
    const pmData = usePMData();
    console.log('ðŸ“¦ PM Data from context:', pmData);

    // Safe extraction with multiple fallbacks
    pmLeaveReqs = pmData?.pmLeaveReqs || [];
    pmDocs = pmData?.pmDocs || [];
    pmHrReports = pmData?.pmHrReports || [];
    pmSchedules = pmData?.pmSchedules || [];
    pmAdvances = pmData?.pmAdvances || [];

    // Ensure they are arrays
    if (!Array.isArray(pmLeaveReqs)) pmLeaveReqs = [];
    if (!Array.isArray(pmDocs)) pmDocs = [];
    if (!Array.isArray(pmHrReports)) pmHrReports = [];
    if (!Array.isArray(pmSchedules)) pmSchedules = [];
    if (!Array.isArray(pmAdvances)) pmAdvances = [];

  } catch (error) {
    console.error('âŒ Failed to get PM data:', error);
  }

  const { user } = useAuth();

  // ===========================================
  // ðŸ›¡ï¸ ABSOLUTELY SAFE FILTERING
  // ===========================================
  let pendingLeaves = 0;
  let pendingDocs = 0;
  let pendingReports = 0;
  let upcomingMeetings = 0;
  let pendingAdvances = 0;

  try {
    pendingLeaves = pmLeaveReqs.filter((r) =>
    r?.status === "pending" || r?.status === "resubmitted"
    ).length;
  } catch (e) {
    console.warn('âš ï¸ Leave filter failed:', e.message);
    pendingLeaves = 0;
  }

  try {
    pendingDocs = pmDocs.filter((d) => d?.status === "pending").length;
  } catch (e) {
    console.warn('âš ï¸ Docs filter failed:', e.message);
    pendingDocs = 0;
  }

  try {
    pendingReports = pmHrReports.filter((r) => r?.status === "pending").length;
  } catch (e) {
    console.warn('âš ï¸ Reports filter failed:', e.message);
    pendingReports = 0;
  }

  try {
    upcomingMeetings = pmSchedules.filter((s) => s?.status === "Scheduled").length;
  } catch (e) {
    console.warn('âš ï¸ Schedules filter failed:', e.message);
    upcomingMeetings = 0;
  }

  try {
    pendingAdvances = pmAdvances.length;
  } catch (e) {
    console.warn('âš ï¸ Advances filter failed:', e.message);
    pendingAdvances = 0;
  }

  // Safe navigation handler
  const handleNavigation = (key) => {
    console.log('ðŸ–±ï¸ Navigate to:', key);
    if (setActiveView && typeof setActiveView === 'function') {
      setActiveView(key);
    }
  };

  // Safe logout handler
  const handleLogout = () => {
    if (onLogout && typeof onLogout === 'function') {
      onLogout();
    } else {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/login';
    }
  };

  return (
    <div
      className={`SB ${sidebarOpen ? "SB-open" : "SB-closed"}`}
      onMouseEnter={() => setSidebarOpen?.(true)}
      onMouseLeave={() => setSidebarOpen?.(false)}
    >
      <div className="SB-hd">
        <img src="/logo.png" alt="AMS" className="SB-logo pmsidebar-inline-1" />
        <div>
          <div className="pmsidebar-inline-2">
            AMSHRMS
          </div>
          <div className="pmsidebar-inline-3">
            Project Manager
          </div>
        </div>
      </div>
      
      <nav className="SB-nav">
        {/* Overview Section */}
        <div className="SB-sec">Overview</div>
        <div
          className={`${"NI" + (activeView === "dashboard" ? " on" : "")} pmsidebar-dyn-1`}
          onClick={() => handleNavigation("dashboard")}>
          
          
          {II("home")}<span>Dashboard</span>
        </div>
        
        {/* Management Section */}
        <div className="SB-sec">Management</div>
        <div
          className={`${"NI" + (activeView === "projects" ? " on" : "")} pmsidebar-dyn-2`}
          onClick={() => handleNavigation("projects")}>
          
          
          {II("briefcase")}<span>Projects</span>
        </div>
        <div
          className={`${"NI" + (activeView === "progress" ? " on" : "")} pmsidebar-dyn-3`}
          onClick={() => handleNavigation("progress")}>
          
          
          {II("trend")}<span>Team Progress</span>
          {upcomingMeetings > 0 &&
          <span className="bg pmsidebar-inline-7">{upcomingMeetings}</span>
          }
        </div>
        <div
          className={`${"NI" + (activeView === "leave" ? " on" : "")} pmsidebar-dyn-4`}
          onClick={() => handleNavigation("leave")}>
          
          
          {II("calendar")}<span>Leave Requests</span>
          {pendingLeaves > 0 &&
          <span className="bg">{pendingLeaves}</span>
          }
        </div>
        <div
          className={`${"NI" + (activeView === "calendar" ? " on" : "")} pmsidebar-dyn-5`}
          onClick={() => handleNavigation("calendar")}>
          
          
          {II("calendar")}<span>Calendar</span>
        </div>
        
        {/* Collaboration Section */}
        <div className="SB-sec">Collaboration</div>
        <div
          className={`${"NI" + (activeView === "announce" ? " on" : "")} pmsidebar-dyn-6`}
          onClick={() => handleNavigation("announce")}>
          
          
          {II("megaphone")}<span>Announcements</span>
        </div>
        <div
          className={`${"NI" + (activeView === "reports" ? " on" : "")} pmsidebar-dyn-7`}
          onClick={() => handleNavigation("reports")}>
          
          
          {II("chart")}<span>HR Reports</span>
          {pendingReports > 0 &&
          <span className="bg pmsidebar-inline-12">{pendingReports}</span>
          }
        </div>
        <div
          className={`${"NI" + (activeView === "hrrequests" ? " on" : "")} pmsidebar-dyn-8`}
          onClick={() => handleNavigation("hrrequests")}>
          
          
          {II("note")}<span>HR Requests</span>
        </div>
        <div
          className={`${"NI" + (activeView === "offboardingmanagement" ? " on" : "")} pmsidebar-dyn-9`}
          onClick={() => handleNavigation("offboardingmanagement")}>
          
          
          {II("logout")}<span>Offboarding Management</span>
        </div>
        <div
          className={`${"NI" + (activeView === "lostreports" ? " on" : "")} pmsidebar-dyn-9`}
          onClick={() => handleNavigation("lostreports")}>
          {II("bell")}<span>Lost Asset Reports</span>
        </div>
        <div
          className={`${"NI" + (activeView === "evaluations" ? " on" : "")} pmsidebar-dyn-9`}
          onClick={() => handleNavigation("evaluations")}>
          {II("note")}<span>IT Evaluations</span>
        </div>
        
        {/* Communication Section */}
        <div className="SB-sec">Communication</div>
        <div
          className={`${"NI" + (activeView === "chat" ? " on" : "")} pmsidebar-dyn-10`}
          onClick={() => handleNavigation("chat")}>
          
          
          {II("message")}<span>Team Chat</span>
        </div>
        <div
          className={`${"NI" + (activeView === "notifications" ? " on" : "")} pmsidebar-dyn-11`}
          onClick={() => handleNavigation("notifications")}>
          
          
          {II("bell")}<span>Notifications</span>
        </div>
        <div
          className={`${"NI" + (activeView === "tickets" ? " on" : "")} pmsidebar-dyn-12`}
          onClick={() => handleNavigation("tickets")}>
          
          
          {II("shield")}<span>Tickets</span>
        </div>

        {/* Approvals Section */}
        <div className="SB-sec">Approvals</div>
        <div
          className={`${"NI" + (activeView === "permissions" ? " on" : "")} pmsidebar-dyn-13`}
          onClick={() => handleNavigation("permissions")}>
          
          
          {II("clock")}<span>Permissions</span>
        </div>
        <div
          className={`${"NI" + (activeView === "advances" ? " on" : "")} pmsidebar-dyn-14`}
          onClick={() => handleNavigation("advances")}>
          
          
          {II("wallet")}<span>Salary Advances</span>
          {pendingAdvances > 0 &&
          <span className="bg pmsidebar-inline-20">{pendingAdvances}</span>
          }
        </div>

        {/* Personal Section */}
        <div className="SB-sec">Personal</div>
        <div
          className={`${"NI" + (activeView === "notes" ? " on" : "")} pmsidebar-dyn-15`}
          onClick={() => handleNavigation("notes")}>
          
          
          {II("folder")}<span>Notes</span>
        </div>
        <div
          className={`${"NI" + (activeView === "people" ? " on" : "")} pmsidebar-dyn-16`}
          onClick={() => handleNavigation("people")}>
          
          
          {II("users")}<span>People</span>
        </div>
      </nav>
      
      <div className="SB-ft">
        <div className="pmsidebar-inline-23">
          <AvatarDisplay src={user?.avatar} name={user?.name} size={34} />
          <div className="pmsidebar-inline-24">
            <div className="pmsidebar-inline-25">
              {user?.name || 'Project Manager'}
            </div>
            <div className="pmsidebar-inline-26">
              {user?.id || 'PM'}
            </div>
          </div>
        </div>
        
        <button
          onClick={handleLogout}
















          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(239,68,68,0.1)";
            e.currentTarget.style.color = "#ef4444";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = "rgba(239,68,68,.8)";
          }} className="pmsidebar-inline-27">
          
          {II("logout")} Sign Out
        </button>
      </div>
    </div>);

}

export default PMSidebar;

